module.exports = __webpack_public_path__ + "img/icon_word.142799ec.svg";